import { render, staticRenderFns } from "./Events.html?vue&type=template&id=171f12ae&scoped=true&external"
import script from "./Events.vue?vue&type=script&lang=js"
export * from "./Events.vue?vue&type=script&lang=js"
import style0 from "./Events.scss?vue&type=style&index=0&id=171f12ae&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171f12ae",
  null
  
)

export default component.exports